'use client'

import { Button, Container, Icon, Navigation, Spacer, Text } from '@vinted/web-ui'
import { ChevronLeft24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  currentSlideIndex: number
  totalSlides: number
  onBackClick: () => void
}

export const SlideNavigation = ({ currentSlideIndex, totalSlides, onBackClick }: Props) => {
  const translate = useTranslate('conversation.phishing_first_time_lister_education')
  const previousPageTranslate = useTranslate('kyc_form.identity_document.photo_tips')

  return (
    <>
      <Spacer size={Spacer.Size.XSmall} />
      <Navigation
        left={
          currentSlideIndex !== 0 && (
            <Container styling={Container.Styling.Tight}>
              <Spacer size={Spacer.Size.Small} />
              <Spacer orientation={Spacer.Orientation.Vertical} size={Spacer.Size.Small} />
              <Button
                styling={Button.Styling.Flat}
                size={Button.Size.Small}
                iconName={ChevronLeft24}
                iconColor={Icon.Color.GreyscaleLevel1}
                onClick={onBackClick}
                inline
                testId="phishing-education-back-button"
                aria={{ 'aria-label': previousPageTranslate('previous_tip') }}
              />
            </Container>
          )
        }
        body={
          <Container styling={Container.Styling.Narrow}>
            <Spacer size={Spacer.Size.XSmall} />
            <Text
              as="span"
              text={`${currentSlideIndex + 1}/${totalSlides}`}
              type={Text.Type.Body}
              theme="amplified"
              aria={{
                'aria-label': translate('a11y.page_count', {
                  page_number: currentSlideIndex + 1,
                  pages_count: totalSlides,
                }),
              }}
            />
          </Container>
        }
      />
      <Spacer size={Spacer.Size.XSmall} />
    </>
  )
}
